import DOMPurify from 'dompurify';
import { useCallback } from 'react';

const useDOMPurify = () => {
  const sanitize = useCallback((html: string) => {
    const sanitizedHtml = DOMPurify.sanitize(html);

    const container = document.createElement('div');
    container.innerHTML = sanitizedHtml;

    const links = container.querySelectorAll('a');
    links.forEach((link) => {
      link.setAttribute('target', '_blank');
    });

    return container.innerHTML;
  }, []);

  return { sanitize };
};

export default useDOMPurify;
